export enum Consumer {
  VDP = 'vdp',
  SRP = 'srp',
  HOME = 'home',
  SEM = 'sem'
}
